import { environment, envs } from 'services/environment';

const PROD_SEGMENT_SOURCE_ID = '8tEfgRCivSBv7oqseie70PwBF8dEE0F7';
const STAGE_SEGMENT_SOURCE_ID = 'tFFPMQDrOUOBmDWwOJrsZOO4epCn28ie';
const ANALYTICS_WRAPPER = 'https://atl-global.atlassian.com/js/atl-global.min.js';

export const initAnalytics = () => {
  const { name } = environment();
  const writeKey = name === envs.PROD ? PROD_SEGMENT_SOURCE_ID : STAGE_SEGMENT_SOURCE_ID;
  if (window.ace) {
    window.ace.analytics.Initializer.initAnalytics(writeKey);
  } else {
    console.warn('Did not load analytics library');
  }
};

export const loadAnalyticsWrapper = () => {
  const script = document.createElement('script');
  script.src = ANALYTICS_WRAPPER;
  script.type = 'text/javascript';
  script.id = 'atl-global';

  script.onload = initAnalytics;
  document.body.appendChild(script);
};

export const trackPage: (pageName: string, data?: Record<string, string | undefined> | undefined) => void = (
  pageName,
  data,
): void => {
  if (window.ace) {
    window.ace.analytics.Tracking.pageView(null, pageName, data);
  } else {
    console.warn('Did not load analytics library');
  }
};

export const trackEvent = (
  action: string,
  actionDesc: string,
  params: Record<string, string | undefined> | undefined = undefined,
): void => {
  const data = params ? { actionDesc, ...params } : { actionDesc };
  if (window.ace) {
    window.ace.analytics.Tracking.trackEvent(action, data);
  } else {
    console.warn('Did not load analytics library');
  }
};
